import React from 'react';
import SVG from 'images/svg/SVG.js';
import { useSelector } from 'react-redux';
import selectors from 'selectors/selectors.js';
import setQuery from 'lib/setQuery.js';
import { action } from 'lib/actionHelpers';
import getFolderEventsById from 'lib/getFolderEventsById.js';
import inboxFoldersSelector from 'screens/inbox/store/inboxFoldersSelector.js';

const AppNotificationDisplay = () => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const notificationFolderId = useSelector(selectors.notificationFolderId);
  const notificationSliderOpen = useSelector(selectors.notificationSliderOpen);
  const todoEvents = useSelector(selectors.todoEvents);
  const folderEvents = useSelector(selectors.folderEvents);
  const folders = useSelector(inboxFoldersSelector);

  const visibleFolders = folders.filter((n) => (n.visibility || []).includes('notificationsSlider'));
  const folderEventMap = Object.fromEntries(visibleFolders.map((n) => [n.id, getFolderEventsById(folderEvents, n.id)]));

  const eventMap = {
    ...folderEventMap,
    todosOverdue: todoEvents,
    todos: todoEvents,
  };

  const handleClick = (e, query) => {
    e.preventDefault();
    e.stopPropagation();
    setQuery({ notificationFolderId: query === notificationFolderId ? null : query });
    const notificationFolderIdEvents = eventMap[query] || [];
    const type = query === 'todos' ? 'updated_todo' : 'new_message';

    const ids = notificationFolderIdEvents.map((n) => {
      if (n.todo) {
        // wtf
        if (n.todo.event_data.todo) {
          return (n.todo.event_data.todo || {}).id;
        }
        return (n.todo.event_data || {}).id;
      }
      return (n.event_data || {}).id;
    });

    if (ids.length > 0) {
      action('ACKNOWLEDGE_EVENT_TYPE', {
        type,
        ids,
        serviceProviderId,
      });
    }
  };

  return (
    <div className={`app-notification-display ${notificationSliderOpen ? 'active' : ''}`}>
      <div className={`notification default`} data-title={'Notifications'} onClick={(e) => handleClick(e, notificationFolderId || 'inbox')}>
        <SVG icon={'TodoAlert'} basic={false} />
      </div>
      {visibleFolders.map((folder, idx) => (
        <div key={idx} className={`notification ${eventMap[folder.id].length ? 'active' : ''}`} onClick={(e) => handleClick(e, folder.id)} data-title={folder.name}>
          <SVG icon={folder.svg} basic={false} />
          <div className={'event-count'}>{eventMap[folder.id].length}</div>
        </div>
      ))}
      <div className={`notification todo ${todoEvents.length ? 'active' : ''}`} onClick={(e) => handleClick(e, 'todos')} data-title={'Todos'}>
        <SVG icon={'Todos'} basic={false} />
        <div className={'event-count'}>{todoEvents.length}</div>
      </div>
    </div>
  );
};

export default AppNotificationDisplay;
